import {
  IGetMyPeersAction,
  IGetMyPeersActionFulfilled,
  IGetMyPeersActionRejected,
  IMyPeersReduxState
} from "../../types";

const initialState: IMyPeersReduxState = {
  completed: false,
  items: [],
  pending: false,
  rejected: false
};

type Action = IGetMyPeersAction | IGetMyPeersActionFulfilled | IGetMyPeersActionRejected;

export default (state = initialState, action: Action): IMyPeersReduxState => {
  const { type } = action;
  switch (type) {
    case "GET_MY_PEERS_LIST":
      return {
        ...state,
        completed: false,
        items: [],
        pending: true,
        rejected: false
      };
    case "GET_MY_PEERS_LIST_FULFILLED":
      if ("payload" in action) {
        return {
          ...state,
          completed: true,
          items: action.payload,
          pending: false,
          rejected: false
        };
      }

    case "GET_MY_PEERS_LIST_REJECTED":
      return {
        ...state,
        completed: true,
        items: [],
        pending: false,
        rejected: true
      };
    default:
      return state;
  }
};
